module.exports = __webpack_public_path__ + "media/components/country-flag/static/xx-0c38cfd457dad4950505cb2bea60c7eb.svg";